(function() {
  var BaseHandler, StringUtils,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  BaseHandler = App.loadClass("core::reports/BaseHandler");

  StringUtils = App.load("core::utils/string");

  exports.Reports_Fulfillment_SubHandler = (function(superClass) {
    extend(Reports_Fulfillment_SubHandler, superClass);

    function Reports_Fulfillment_SubHandler() {
      this.createClusterIcon = bind(this.createClusterIcon, this);
      return Reports_Fulfillment_SubHandler.__super__.constructor.apply(this, arguments);
    }

    Reports_Fulfillment_SubHandler.prototype.init = function() {
      this.markers = [];
      this.layoutUrl = 'backend/portal/reports/fulfillment';
      this.filterUrl = 'backend/portal/reports/fulfillment/filters';
      this.layoutSelector = "#reports_fulfillment_tab";
      this.parent.topBuffer = function() {
        return parseInt(App.sidebar.element.outerHeight()) - 55;
      };
      this.oldMaxZoom = App.map.options.maxZoom;
      App.map.options.maxZoom = 13;
      this.availableStages = {
        Cancelled: "#BE4948",
        Delivered: "#3A894C",
        Invoiced: "#F89406",
        Mult: "#dddddd",
        Ordered: "#ffffff",
        Processing: "#888888",
        PrintDelTkt: "#e6c2c2",
        ReadytoShip: "#6d5a8c",
        Returned: "#BE4948",
        RMA: "#333333",
        Shipped: "#888888",
        Staged: "#3286AB",
        Transfer: "#825f48"
      };
      this.icons = {};
      this.generateMarkerIcons();
      return this.initFilters();
    };


    /*
     *
     * Initialize marker icons. These are the pushpins that represent
     * an order on the map, and they are colorcoded by order stage.
     */

    Reports_Fulfillment_SubHandler.prototype.generateMarkerIcons = function() {
      var color, ref, results, stage;
      ref = this.availableStages;
      results = [];
      for (stage in ref) {
        color = ref[stage];
        results.push(this.icons[stage] = new L.mapbox.marker.icon({
          "marker-size": "medium",
          "marker-color": color,
          "marker-symbol": "circle"
        }));
      }
      return results;
    };

    Reports_Fulfillment_SubHandler.prototype.initFilters = function() {
      this.resetFilters();
      this.parent.filters.findInGroup('farms').disableFilter();
      this.parent.filters.findInGroup('fields').disableFilter();
      this.parent.filters.importGroup({
        name: "Geo-Fulfillment Filters",
        filters: [
          {
            name: 'statuses',
            display_name: 'Order Status',
            "class": 'dropup',
            values: []
          }
        ]
      });
      return this.setDefaultsAndRun();
    };

    Reports_Fulfillment_SubHandler.prototype.afterLoadLayout = function(sel, data) {
      var j, len, oid, ref;
      if (this._post != null) {
        this._post.abort();
      }
      if (this._timer != null) {
        clearTimeout(this._timer);
      }
      App.layer_store.empty();
      this.markerClusterer = new L.MfMarkerClusterGroup({
        iconCreateFunction: this.createClusterIcon
      });
      App.layer_store.store("marker_cluster", this.markerClusterer);
      $("#map_canvas").undelegate().delegate('.get-directions-form .btn', 'click', function(e) {
        var form;
        e.preventDefault();
        form = $(this).parents('form').serialize();
        return window.open("http://maps.google.com/maps?" + form + "&hl=en");
      });
      this.orderlist = [];
      ref = data.data.orders;
      for (j = 0, len = ref.length; j < len; j++) {
        oid = ref[j];
        this.orderlist.push(oid.id);
      }
      return this.fetchOrder();
    };

    Reports_Fulfillment_SubHandler.prototype.createClusterIcon = function(cluster) {
      var counts, i, iconClass, j, k, len, markers, maxCat, maxCt, v;
      markers = cluster.getAllChildMarkers();
      counts = {};
      for (j = 0, len = markers.length; j < len; j++) {
        i = markers[j];
        if (counts[i.order_stage] == null) {
          counts[i.order_stage] = 0;
        }
        counts[i.order_stage]++;
      }
      maxCt = 0;
      maxCat = '';
      for (k in counts) {
        v = counts[k];
        if (v > maxCt) {
          maxCt = v;
          maxCat = k;
        }
      }
      maxCat = maxCat.replace(/\s/g, '');
      iconClass = 'gfil-marker-cluster-' + StringUtils.allLower(maxCat);
      return new L.DivIcon({
        html: '<div class="hex-outer"> <div class="hex-left"></div> <div class="hex-middle"></div> <div class="hex-right"></div> </div> <div class="hex-inner"> <div class="hex-left"></div> <div class="hex-middle"></div> <div class="hex-right"></div> </div> <div class="count-text">' + cluster.getChildCount() + '</div>',
        className: 'marker-cluster ' + iconClass,
        iconSize: new L.Point(44, 44)
      });
    };

    Reports_Fulfillment_SubHandler.prototype.fetchOrder = function() {
      var ids, ths;
      ids = this.orderlist;
      ths = this;
      if (ids.length === 0) {
        return null;
      }
      return this._post = $.post('backend/portal/reports/fulfillment/fulfillment', {
        ids: ko.toJSON(ids)
      }, function(data) {
        var e, first_stage, infoString, j, len, master, n, order, percent, ref, s, w, warehouse1, warehouse2, warehouseflag;
        if (data.data.length !== 0) {
          master = data.data[0];
          first_stage = master.status_name;
          n = s = master.lat;
          e = w = master.lng;
          infoString = "";
          warehouse1 = "";
          warehouse2 = "";
          warehouseflag = true;
          ref = data.data;
          for (j = 0, len = ref.length; j < len; j++) {
            order = ref[j];
            percent = parseInt((order.status_qty / order.order_qty) * 100);
            if (master.id === order.id) {
              if (warehouseflag === true) {
                infoString = infoString.concat(order.status_name + " " + percent + "%<br>");
                warehouseflag = false;
                warehouse1 = order.warehouse_name;
              } else {
                warehouseflag = true;
                warehouse2 = order.warehouse_name;
              }
            } else {
              ths.placeMarker(master, order, infoString, first_stage, warehouse1, warehouse2);
              master = order;
              infoString = order.status_name + " " + percent + "%<br>";
              warehouse1 = order.warehouse_name;
              warehouse2 = "";
              first_stage = master.status_name;
              warehouseflag = false;
            }
          }
          ths.placeMarker(master, order, infoString, first_stage, warehouse1, warehouse2);
          App.map.fitBounds(App.layer_store.getBounds());
          ths.parent.msg.message_writer('success', 'Report Finished');
          return ths.parent.msg.message_writer('hide');
        }
      });
    };

    Reports_Fulfillment_SubHandler.prototype.placeMarker = function(master, order, infoString, first_stage, warehouse1, warehouse2) {
      var Location, mk, ref, ref1, ths;
      ths = this;
      infoString = "<table class='table table-condensed'> <tr><th>Order</th><td>" + master.id + "</td></tr> <tr><th>Grower Name</th><td>" + master.user_name + "</td></tr> <tr><th>Fulfillment Stage</th><td>" + infoString + "</td> <tr><th>Closest Warehouses</th><td>" + warehouse1 + ", " + warehouse2 + "</td></tr> </table>";
      Location = [(ref = master.lat) != null ? ref : 0, (ref1 = master.lng) != null ? ref1 : 0];
      if (this.icons[first_stage.replace(/\s/g, '')]) {
        mk = new L.marker(Location, {
          icon: this.icons[first_stage.replace(/\s/g, '')]
        });
        mk.order_stage = first_stage;
        mk.bindPopup(infoString);
        return this.markerClusterer.addLayer(mk);
      }
    };

    Reports_Fulfillment_SubHandler.prototype.destroy = function() {
      this.parent.filters.removeGroup('Geo-Fulfillment Filters');
      App.map.options.maxZoom = this.oldMaxZoom;
      App.layer_store.empty();
      this.parent.topBuffer = function() {
        return 0;
      };
      return Reports_Fulfillment_SubHandler.__super__.destroy.call(this);
    };

    return Reports_Fulfillment_SubHandler;

  })(BaseHandler);

}).call(this);
